import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHeading } from "@/components/Bits";

const FAQS = [
  ["What is ASURE?", "ASURE is a modern Indian nutrition and wellness brand focused on daily nutrition, natural ingredients and simple everyday routines."],
  ["What is Spirulina?", "Spirulina is a naturally occurring blue-green algae, valued as a natural source of protein, vitamins, minerals and antioxidants."],
  ["What is Sea Buckthorn?", "Sea Buckthorn is a bright orange berry rich in natural antioxidants and Omega 3, 6, 7 & 9."],
  ["How do I use ASURE Daily Nutrition?", "Take 2 capsules daily, preferably after meals, as part of a consistent 30-day routine."],
  ["How many capsules are included?", "Each 30-day box contains 60 capsules — a 30-day supply at 2 capsules per day."],
  ["Is ASURE suitable for everyone?", "For medical and safety-related questions, please consult an appropriate healthcare professional before starting any new nutrition product."],
  ["How should I store the product?", "Store in a cool, dry place away from direct sunlight."],
  ["Where are ASURE products manufactured?", "Manufacturer details will be shared on-pack. [MANUFACTURER NAME]"],
  ["How can I verify my product?", "Every ASURE box carries a SCAN & VERIFY QR code — scan it to view batch, manufacturing and expiry information."],
  ["What is the return policy?", "We offer a 7-day return window on unopened boxes. See our shipping and returns section for details."],
];

export default function Faq() {
  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 pt-14 pb-24">
      <SectionHeading eyebrow="FAQ" title="Common questions" />
      <div className="mt-10">
        <Accordion type="single" collapsible>
          {FAQS.map(([q, a], i) => (
            <AccordionItem key={i} value={`i${i}`} data-testid={`faq-${i}`}>
              <AccordionTrigger className="text-left font-display text-xl">{q}</AccordionTrigger>
              <AccordionContent className="text-asure-text2 leading-relaxed">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
